import api from './baseApi';

export type InformationContentType = 'text' | 'files' | 'contactList' | 'teams';
export type InformationContactField =
  'name' | 'phone' | 'email' | 'company' | 'notes';

export interface InformationSectionDto {
  title: string;
  content: string;
  fileIds?: string[];
  contentTypes?: InformationContentType[];
  contactFields?: InformationContactField[];
  excludedContactIds?: string[];
  teamGroupId?: string;
  contactMembers?: {
    id: string;
    name: string;
    avatarUrl?: string;
    phone?: string;
    email?: string;
    company?: string;
    notes?: string;
    contactShareConsent?: 'approved' | 'declined';
  }[];
}

export interface InformationDto {
  _id: string;
  tribe_id: string;
  sections: InformationSectionDto[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateInformationRequest {
  circleId: string;
  sections: InformationSectionDto[];
}

export const informationApi = {
  async createForm({
    circleId,
    ...body
  }: CreateInformationRequest): Promise<InformationDto> {
    const response = await api.post(`/tribes/${circleId}/information`, body);
    return response.data.result;
  },

  async getFormForCircle(circleId: string): Promise<InformationDto | null> {
    const response = await api.get(`/tribes/${circleId}/information`);
    return response.data.result ?? null;
  },
};

export const documentsApi = {
  async createForm({
    circleId,
    ...body
  }: CreateInformationRequest): Promise<InformationDto> {
    const response = await api.post(`/tribes/${circleId}/documents`, body);
    return response.data.result;
  },

  async getFormForCircle(circleId: string): Promise<InformationDto | null> {
    const response = await api.get(`/tribes/${circleId}/documents`);
    return response.data.result ?? null;
  },
};
